import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Step } from '../global-stepper/global-stepper.component';

@Component({
    selector: 'app-floating-tip',
    templateUrl: './floating-tip.component.html',
    styleUrls: ['./floating-tip.component.scss']
})
export class FloatingTipComponent implements OnInit {
    @Input() steps: Step[] = [];
    @Input() initialIndex = 0;
    @Input() buttonLabel = 'Hablar con un experto';
    @Input() linkLabel = 'Siguiente consejo';

    @Output() stepChange = new EventEmitter<Step>();
    @Output() primary = new EventEmitter<Step>();
    @Output() closed = new EventEmitter<void>();
    @Output() linkBack = new EventEmitter<void>();
    visible = true;
    hide() { this.visible = false; document.getElementById('screenBlocker-floating-tip').style.display = 'none'; this.closed.emit(); }

    ngOnInit() {
        document.getElementById('screenBlocker-floating-tip').style.display = 'block';
    }
}


